<template>
  <div class="kefu-page">
    <div v-if="loading" class="kefu-state">{{ $t('Loading...') }}</div>
    <div v-else-if="error" class="kefu-state">
      <p>{{ error }}</p>
      <button v-if="url" type="button" class="kefu-btn" @click="openExternal">{{ $t('Online service') }}</button>
    </div>
    <div
      v-else-if="url"
      style="height: calc(100vh - 50px); overflow-y: scroll; -webkit-overflow-scrolling: touch"
    >
      <iframe
        style="height: calc(100% - 1.5rem); width: 100%"
        ref="iframe"
        :src="url"
        scrolling="auto"
        frameborder="0"
        allow="microphone; camera; autoplay; clipboard-read; clipboard-write"
      ></iframe>
    </div>
  </div>
</template>
<script>
export default {
  name: 'kefu',
  data() {
    return {
      url: null,
      loading: true,
      error: '',
    };
  },
  created() {
    this.getservicerurl();
  },
  methods: {
    toast(ok, msg) {
      let p = this.$parent;
      while (p) {
        if (typeof p.showTost === 'function') {
          p.showTost(ok ? 1 : 0, msg);
          return;
        }
        p = p.$parent;
      }
    },
    fillKfUrl(url) {
      const u = (this.$store && this.$store.state && this.$store.state.userInfo) || {};
      const id = String(u.id || u.userid || u.user_id || '');
      const name = encodeURIComponent(u.username || u.account || u.name || '');
      return String(url || '')
        .replace(/\{visiter_id\}/gi, id)
        .replace(/\{visiter_name\}/gi, name)
        .replace(/\{uid\}/gi, id)
        .replace(/\{userid\}/gi, id)
        .replace(/\{user_id\}/gi, id)
        .replace(/\{name\}/gi, name)
        .replace(/\{username\}/gi, name);
    },
    isSafeHttpUrl(url) {
      try {
        const u = new URL(url, window.location.href);
        return u.protocol === 'http:' || u.protocol === 'https:';
      } catch (e) {
        return false;
      }
    },
    openExternal() {
      if (this.url && this.isSafeHttpUrl(this.url)) {
        window.location.href = this.url;
      }
    },
    applyUrl(raw) {
      const url = this.fillKfUrl(raw);
      if (!url || !this.isSafeHttpUrl(url)) {
        this.loading = false;
        this.error = 'CS url empty';
        this.toast(0, this.error);
        return false;
      }
      // 客服站经常拦 iframe，直接整页打开（与空白页相比更稳）
      this.url = url;
      this.loading = false;
      window.location.href = url;
      return true;
    },
    // 打开客服：优先用 /api/app 已下发的 service_link，避免 getservicerurl 被劫持/跨域
    getservicerurl() {
      const cached =
        (this.$store.state.appInfo &&
          (this.$store.state.appInfo.service_link || this.$store.state.appInfo.kf_url)) ||
        '';
      if (cached && this.applyUrl(cached)) {
        return;
      }

      this.loading = true;
      this.error = '';
      this.$apiFun
        .post('/api/getservicerurl', {}, { maxRedirects: 0 })
        .then((res) => {
          if (res.code != 200) {
            this.loading = false;
            this.error = res.message || 'CS unavailable';
            this.toast(0, this.error);
            return;
          }
          if (!this.applyUrl(res.data && res.data.url)) {
            return;
          }
        })
        .catch(() => {
          this.loading = false;
          this.error = 'CS unavailable';
          this.toast(0, this.error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.kefu-page {
  min-height: calc(100vh - 50px);
  background: #f6efe4;
}
.kefu-state {
  padding: 48px 20px;
  text-align: center;
  color: #8a6a45;
  font-size: 14px;
}
.kefu-btn {
  margin-top: 16px;
  height: 36px;
  padding: 0 18px;
  border-radius: 20px;
  border: 1px solid #d1a03e;
  background: #fff;
  color: #8f501f;
  font-size: 13px;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/mode/kefu.vue